import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {User, UserService} from '../../../shared';
import {FormControl} from '@angular/forms';
import {Response} from '@angular/http';

@Component({
    selector: 'jhi-link-user-component',
    templateUrl: './link-user.component.html'
})
export class LinkUserComponent implements OnInit {

    @Input() linkedUsers: User[];
    @Output() onErrorEvent: EventEmitter<String> = new EventEmitter();
    @Output() linkedUsersChange: EventEmitter<User> = new EventEmitter();

    userListe: User[] = [];
    userListeShow = false;

    userEmail: string;
    userSearchControl = new FormControl();

    constructor(private userService: UserService
    ) {
        this.userSearchControl.valueChanges
            .debounceTime(500)
            .distinctUntilChanged()
            .subscribe(userSearch => this.searchUserInLdap(userSearch));
    }

    ngOnInit() {
    }

    /**
     * Select a user to add/remove him to/from the list linkedUsers
     * @param user to add/remove
     */
    selectUser(user: User) {
        let idx = this.linkedUsers ? this.linkedUsers.findIndex(f => f.email === user.email) : -1;
        if (idx > -1) {
            this.linkedUsers.splice(idx, 1);
        } else {
            if (this.linkedUsers == null) {
                this.linkedUsers = [];
            }
            this.linkedUsers.push(user);
        }
        this.linkedUsersChange.emit(this.linkedUsers);
        this.hideUserListeShow();
        this.userSearchControl.setValue('');
        this.userListe = [];
    }

    /**
     * Add a User from an email -> do not have to be internal user
     * The user must exist in Cadens database jhi_user
     */
    addLdapUser(user: User) {
        if (user != null) {
            this.selectUserByMailInCadens(user.email, user);
        }
    }


    /**
     * Add a User from an email -> do not have to be internal user
     * The user must exist in Cadens database jhi_user
     */
    addUserByEmail(userEmail: String) {
        if (userEmail != null) {
            this.selectUserByMailInCadens(userEmail, null);
        }
    }

    private selectUserByMailInCadens(userEmail: String, ldapUser: User) {
        this.userService.find(userEmail.toString()).subscribe(
            user => {
                // If found, link him to the formation
                this.selectUser(user);
                this.userEmail = null;
            },
            (res: Response) => {
                // si user Ldap on le rajoute même si il n'est pas dans Cadens
                if (ldapUser != null) {
                    ldapUser.id = -1;
                    this.selectUser(ldapUser);
                    this.userEmail = null;
                } else {
                    this.onErrorMessage('cadensApp.formation.error.pasCompteUtilisateurDansCadens', null);
                }
            });
    }

    onErrorMessage(message: any, params: any) {
        // JhiAlertComponent.onErrorMessage(this.alertService, message, params);
        this.onErrorEvent.emit(message);
    }

    showUserListeShow() {
        // Show the dropdown of users
        if (this.userListe != null && this.userListe.length > 0) {
            this.userListeShow = true;
        }
    }

    hideUserListeShow() {
        this.userListeShow = false;
    }

    /**
     * Search a user from the LDAP repo on the server and display the list
     * @param search name of the user to search
     */
    private searchUserInLdap(search) {
        if (search != null && search.length > 3) {
            this.userService.queryLDAP({search: search}).subscribe(
                res => {
                    this.userListe = res.json();
                    this.userListeShow = true;
                });
        }
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/formation/link-user/link-user.component.ts